// The V2 Customer Portal is disabled unless the build sets REACT_APP_CUSTOMER_PORTAL=true exactly.
// The backend enforces the same switch; this mirrors it so portal URLs and actions are unreachable from the UI.
export const customerPortalEnabled = () => process.env.REACT_APP_CUSTOMER_PORTAL === 'true';

// Staff-facing portal actions (invite / resend) also honour /master/capabilities `features.customerPortal`.
export const canInviteToCustomerPortal = capabilities => customerPortalEnabled() && capabilities?.features?.customerPortal !== false;

// Where a customer session or customer URL lands: the portal login when enabled, otherwise the normal login.
export const customerLoginPath = () => (customerPortalEnabled() ? '/customer/login' : '/login');
export const customerHomePath = () => (customerPortalEnabled() ? '/customer/dashboard' : '/login');
